import { Link } from "react-router-dom";

const footerLinks = {
  explore: [
    { label: "热门电影", path: "/category/movie" },
    { label: "热播电视剧", path: "/category/tv" },
    { label: "热门综艺", path: "/category/variety" },
    { label: "热门动漫", path: "/category/anime" },
  ],
  about: [
    { label: "关于我们", path: "/about" },
    { label: "联系方式", path: "/about" },
    { label: "用户协议", path: "#" },
    { label: "隐私政策", path: "#" },
  ],
  articles: [
    { label: "影视资讯", path: "/article/article-1" },
    { label: "观影指南", path: "/article/article-2" },
    { label: "深度剧评", path: "/article/article-3" },
    { label: "导演专访", path: "/article/article-6" },
  ],
};

export default function Footer() {
  return (
    <footer className="bg-background-900 border-t border-background-800/50">
      <div className="w-full px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 mb-10">
          <div>
            <Link to="/" className="flex items-center gap-2 mb-4 cursor-pointer">
              <div className="w-8 h-8 flex items-center justify-center">
                <i className="ri-movie-2-line text-xl text-primary-500"></i>
              </div>
              <span className="text-lg font-bold font-heading text-foreground-50">爱看影院</span>
            </Link>
            <p className="text-sm text-foreground-400 leading-relaxed">
              爱看影院影视大全免费在线观看，免费电影、免费电视剧、热播综艺一网打尽，海量高清资源不缓冲流畅播放。
            </p>
            <div className="flex items-center gap-3 mt-4">
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-800/50 text-foreground-400 hover:text-primary-500 hover:bg-background-800 transition-colors cursor-pointer" aria-label="微博">
                <i className="ri-weibo-line"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-800/50 text-foreground-400 hover:text-primary-500 hover:bg-background-800 transition-colors cursor-pointer" aria-label="微信">
                <i className="ri-wechat-line"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-800/50 text-foreground-400 hover:text-primary-500 hover:bg-background-800 transition-colors cursor-pointer" aria-label="B站">
                <i className="ri-bilibili-line"></i>
              </a>
            </div>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-foreground-200 mb-4">探索发现</h3>
            <ul className="space-y-2.5">
              {footerLinks.explore.map((link) => (
                <li key={link.label}>
                  <Link
                    to={link.path}
                    className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-foreground-200 mb-4">关于</h3>
            <ul className="space-y-2.5">
              {footerLinks.about.map((link) => (
                <li key={link.label}>
                  <Link
                    to={link.path}
                    className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-foreground-200 mb-4">热门文章</h3>
            <ul className="space-y-2.5">
              {footerLinks.articles.map((link) => (
                <li key={link.label}>
                  <Link
                    to={link.path}
                    className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="border-t border-background-800/50 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} 爱看影院 aikanyingyuan.com 版权所有
          </p>
          <p className="text-xs text-foreground-600">
            本站内容仅供学习交流，不存储任何视频文件
          </p>
        </div>
      </div>
    </footer>
  );
}